import { useLocation } from "react-router-dom";
import { AgGrid, Flex } from "@jsq/ds/core";
import { OnboardingMenuSlot } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingMenuSlot";
import { OnboardingStatusLabel } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingStatusLabel";
import { OnboardingUnlinkMenu } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingUnlinkMenu";
import { OnboardingViewCaseLink } from "~/pages/Compliance/Common/OnboardingStatus/OnboardingViewCaseLink";
import { resolveOnboardingState } from "~/pages/Compliance/Common/OnboardingStatus/resolveOnboardingState";
import {
  onboardingCell,
  onboardingCellWarning,
} from "~/pages/Compliance/Common/OnboardingStatus/styles_vanilla.css";
import { type TypedAGGridCellRenderParams } from "~/pages/Compliance/ComplianceTable/types";
import { RowActionsMenu } from "../RowActionsMenu";
import { type ComplianceEntityRow } from "../types";

export const OnboardingStatusRenderer = (
  params: TypedAGGridCellRenderParams<ComplianceEntityRow>,
) => {
  const location = useLocation();

  if (!params.data) {
    return null;
  }
  const { data } = params;
  const state = resolveOnboardingState(data.onboardingStatus);
  const isActionRequired = state.kind === "action-required";
  const clientId = Number(new URLSearchParams(location.search).get("clientId"));
  const canUnlink = Number.isInteger(clientId) && clientId > 0;

  let menu = null;
  if (isActionRequired) {
    menu = <RowActionsMenu entityId={data.id} entityName={data.name ?? ""} />;
  } else if (state.kind === "status" && (canUnlink || data.onboardingCaseId != null)) {
    menu = (
      <>
        {canUnlink && (
          <OnboardingUnlinkMenu
            subjectKind="entity"
            subjectId={data.id}
            subjectName={data.name ?? ""}
            arenaId={clientId}
            onUnlinked={() => (params.api as AgGrid.GridApi).refreshServerSide({ purge: true })}
          />
        )}
        {data.onboardingCaseId != null && (
          <OnboardingViewCaseLink caseId={data.onboardingCaseId} />
        )}
      </>
    );
  }

  return (
    <Flex className={isActionRequired ? onboardingCellWarning : onboardingCell}>
      <OnboardingStatusLabel state={state} />
      {menu && <OnboardingMenuSlot>{menu}</OnboardingMenuSlot>}
    </Flex>
  );
};

export default OnboardingStatusRenderer;
